import { render, staticRenderFns } from "./ErrorHelpIcon.vue?vue&type=template&id=4f4c68b7&"
import script from "./ErrorHelpIcon.vue?vue&type=script&lang=js&"
export * from "./ErrorHelpIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports